<template>
  <div class="row">
    <BrandWizardNavigation :brand-id="$route.params.id" />
    <div class="col">
      <b-card>
        <template #header>
          <strong>Kurir</strong>
        </template>
        <div class="text-muted">Halaman Kurir akan tersedia di versi berikutnya.</div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import BrandWizardNavigation from '@/components/brand/BrandWizardNavigation.vue'

export default {
  components: { BCard, BrandWizardNavigation },
  mounted() {
    this.$store.dispatch('brandV2/getDetail', this.$route.params.id)
  },
}
</script>
